import { ConfiguratorOptions } from '@empathybroker/ebx-gluon';

export function rebindContainer({ container }: ConfiguratorOptions) {

}
